import classNames from 'classnames'
import { memo } from 'react'

import { LoaderIcon } from './Icon'

import styles from './Loader.module.scss'

export interface ILoaderProps {
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Size of the Loader
   */
  dimension?: { width?: number; height?: number }
}

export const Loader = memo(({ dimension, className }: ILoaderProps) => (
  <div className={classNames(styles.root, className, 'loader')} data-testid={'loader'}>
    <LoaderIcon
      width={(dimension && dimension.width) || 60}
      height={(dimension && dimension.height) || 60}
    />
  </div>
))

Loader.displayName = 'Loader'
